import { render } from "./AddressModal.vue?vue&type=template&id=0d1583a8&ts=true"
import script from "./AddressModal.ts?vue&type=script&lang=ts&external"
export * from "./AddressModal.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__